import {
  getNameDescriptionTableColumn,
  getCopyWithContentTableColumn,
  getBrandTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: 'SKU_ID',
      }),
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        showDesc: false,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.name }</side-page-trigger>
          )
        },
      }),
      getCopyWithContentTableColumn({
        field: 'service',
        sortable: true,
        title: i18n.t('op_26'),
      }),
      getBrandTableColumn({ field: 'provider' }),
      getCopyWithContentTableColumn({
        field: 'sku_service',
        title: i18n.t('op_14'),
      }),
      getCopyWithContentTableColumn({
        field: 'sku',
        title: i18n.t('op_15'),
      }),
    ]
  },
}
